import { event } from 'jquery'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'form',
    'card',
    'errors',
    'terms',
    'marketingOptIn',
    'submit',
    'paymentFields',
    'paymentCollectionInfo',
    'paymentCollectionSecondaryInfo',
    'paymentForm'
  ]
  static values = { "useExistingCard": Boolean, themeName: String, host: Boolean, currency: String, price: String, participants: Number, date: Object,  hasCustomQuestions: Boolean, hasCustomBranding: Boolean}

  connect() {
    this.stripe = Stripe(this.data.get('public-key'))
    const style = JSON.parse(this.data.get('style'))
    const elements = this.stripe.elements({
      fonts: [
        {
          cssSrc: 'https://use.typekit.net/wcy2cwh.css',
        },
      ],
    })

    this.cardNumber = elements.create('cardNumber', {
      style: style,
      placeholder: '0000 0000 0000 0000',
    })
    this.cardExpiry = elements.create('cardExpiry', {
      style: style,
      placeholder: 'Expiry',
    })
    this.cardCVC = elements.create('cardCvc', {
      style: style,
      placeholder: 'CVC',
    })

    this.cardNumber.mount('#card-number')
    this.cardExpiry.mount('#card-expiry-date')
    this.cardCVC.mount('#card-cvc')

    this.originalSubmitText = this.submitTarget.innerText
    this.determineButtonValidity()
  }

  change(event) {
    if (event.error) {
      this.errorsTarget.textContent = event.error.message
    } else {
      this.errorsTarget.textContent = ''
    }
  }

  showPaymentError() {
    $('.payment-modal').addClass('active')
    $('body').addClass('modal-shown')
  }

  cannotUseExistingCard() {
    $("#user_use_existing_card").prop("checked", false).parent().remove()
    $(this.paymentFormTarget).removeClass('hidden')
    $('.invalid-existing-card-modal').addClass('active')
    $('body').addClass('modal-shown')
  }

  paymentIntents(event) {
    var $this = this
    event.preventDefault()

    if (
      document.getElementById('user_accepted_terms') &&
      !document.getElementById('user_accepted_terms').checked
    ) {
      setTimeout(function () {
        $('input[data-disable-with], button[data-disable-with]').each(function () {
          Rails.enableElement(this)
        })
        $this.determineButtonValidity()
        $this.submitTarget.innerText = $this.originalSubmitText
        $(".must-accept").addClass("with-error")
      }, 500)

      return
    }

    var user_data = {
      email: $('#order_purchase > div.user-inputs #user_email').last().val(),
      contact_number: document.getElementById('user_contact_number').value,
      billing_address_line_1: document.getElementById('user_billing_address_line_1').value,
      billing_address_line_2: document.getElementById('user_billing_address_line_2').value,
      billing_address_city: document.getElementById('user_billing_address_city').value,
      billing_address_state: document.getElementById('user_billing_address_state').value,
      billing_address_country: document.getElementById('user_billing_address_country').value,
      billing_address_postcode: document.getElementById('user_billing_address_postcode').value
    }

    var partner_user_data = {}

    // optionals
    if (document.getElementById('user_first_name')) {
      user_data['first_name'] = document.getElementById(
        'user_first_name'
      ).value
    }
    if (document.getElementById('user_last_name')) {
      user_data['last_name'] = document.getElementById(
        'user_last_name'
      ).value
    }
    if (document.getElementById('user_company_name')) {
      user_data['company_name'] = document.getElementById(
        'user_company_name'
      ).value
    }
    if (document.getElementById('user_external_reference')) {
      user_data['external_reference'] = document.getElementById(
        'user_external_reference'
      ).value
    }

    // vat is optional
    if (document.getElementById('user_vat_number')) {
      user_data['vat_number'] = document.getElementById(
        'user_vat_number'
      ).value
    }

    if (document.getElementById('partner_user_vat_number')) {
      partner_user_data['vat_number'] = document.getElementById(
        'partner_user_vat_number'
      ).value
    }

    // terms - if not on page
    if (document.getElementById('accepted_terms')) {
      user_data['accepted_terms'] = document.getElementById(
        'user_accepted_terms'
      ).checked
      user_data['opted_in_for_marketing'] = document.getElementById(
        'user_opted_in_for_marketing'
      ).checked
    } else {
      user_data['accepted_terms'] = true
    }

    if (document.getElementById('user_use_existing_card')) {
      user_data['use_existing_card'] = document.getElementById('user_use_existing_card').checked
    }

    $.ajax({
      type: 'POST',
      url: this.data.get('stripe-token-url'),
      data: {
        user: user_data,
        partner_user: partner_user_data,
        id: `${this.data.get('order-id')}`,
      },
      beforeSend: function () { },
      success: function (data) {
        $this.intentSecret = data.secret
        $this.submitPayment()
      },
      error: function (err) {
        if (err.status === 412) {
          var obj = $(err.responseText)
          $('.user-inputs').replaceWith(obj.find('.user-inputs'))
          $('.address-inputs').replaceWith(obj.find('.address-inputs'))

          if ($('.user-inputs').find('.is-invalid').length) {
            // copy email error across to main field
            $this.handleEmailErrors()
            $this.scrollToElement($('.user-inputs'))
          }
          else if ($('.address-inputs').find('.is-invalid').length) {
            $this.scrollToElement($('.address-inputs'))
          }
        }

        if (err.status === 410) {
          $this.cannotUseExistingCard()
        } else {
          // show error modal
          $this.showPaymentError()
        }

        // re-enable buttons
        $('input[data-disable-with], button[data-disable-with]').each(function () {
          Rails.enableElement(this)
        })
        $this.determineButtonValidity()
        $this.submitTarget.innerText = $this.originalSubmitText
      },
    })
  }

  handleEmailErrors() {
    const $invalidEmail = $('.user-inputs').find('#user_email.is-invalid')
    const $realEmail = $('[data-quote-target=userEmailInput]')
    const $existingErrorLine = $realEmail.parent().find('div')
    if ($invalidEmail.length) {
      const $error = $invalidEmail.parent().find('div')
      
      $realEmail.addClass('is-invalid').removeClass('is-valid')
      if ($existingErrorLine.length) {
        $existingErrorLine.replaceWith($error)
      } else {
        $realEmail.parent().append($error)
      }
    } else {
      $realEmail.removeClass('is-invalid').addClass('is-valid')
      $existingErrorLine.remove()
    }
  }

  scrollToElement($element) {
    $('html, body').animate({ scrollTop: $element.offset().top - 250 }, 300)
  }

  submitPayment() { 
    mixpanel.track('Payment Submitted', {
      'themeName': this.themeNameValue,
      'host': this.hostValue,
      'currency': this.currencyValue,
      'price': this.priceValue,
      'participants': this.participantsValue,
      'date': this.dateValue["date"],
      'hasCustomQuestions': this.hasCustomQuestionsValue,
      'hasCustomBranding': this.hasCustomBrandingValue
    }, {send_immediately: true});

    var cardholderName;
    if (document.getElementById('partner_user_cardholder_name')) {
      cardholderName = document.getElementById('partner_user_cardholder_name').innerHTML
    } else {
      cardholderName = document.getElementById('user_cardholder_name').innerHTML
  
      if (!cardholderName || cardholderName.length == 0) {
        document.getElementById('user_cardholder_name').innerHTML = $('#order_purchase > div.user-inputs #user_email').last().val().split("@")[0];
        cardholderName = document.getElementById('user_cardholder_name').innerHTML

        if (!cardholderName || cardholderName.length == 0) {
          alert("Sorry, it appears this account has no name set. Please provide this within the \"Settings\" screen in your Portal account.")
          // re-enable buttons
          $('input[data-disable-with], button[data-disable-with]').each(function () {
            Rails.enableElement(this)
          })
          this.submitTarget.innerText = this.originalSubmitText
          return;
        }
      }
    }

    var cardButton = document.getElementById('card-button')

    var line1 = document.getElementById('user_billing_address_line_1').value
    var line2 = document.getElementById('user_billing_address_line_2').value
    var city = document.getElementById('user_billing_address_city').value
    var state = document.getElementById('user_billing_address_state').value
    var country = document.getElementById('user_billing_address_country')
      .value
    var postcode = document.getElementById('user_billing_address_postcode')
      .value

    if (parseInt($('.price-amount').html())) {
      if (window.proceedWithoutPayment || this.useExistingCardValue) {
        $('.activation-form').submit()
      } else {
        let $this = this;
        this.stripe
          .handleCardSetup(this.intentSecret, this.cardNumber, {
            payment_method_data: {
              billing_details: {
                name: cardholderName,
                address: {
                  line1: line1,
                  line2: line2,
                  city: city,
                  state: state,
                  country: country,
                  postal_code: postcode,
                },
              },
            },
          })
          .then(function (result) {
            if (result.error) {
              // Display error.message in your UI.
              if (result.error.message) {
                alert(result.error.message)
              }

              // show error modal
              $this.showPaymentError()

              // re-enable buttons
              $('input[data-disable-with], button[data-disable-with]').each(function () {
                Rails.enableElement(this)
              })
              $this.scrollToElement($('.card-details-inputs'))
              $this.submitTarget.innerText = $this.originalSubmitText
            } else {
              // The payment has succeeded. Display a success message.
              console.log('The payment has succeeded')
              $('.activation-form').submit()
            }
          })
      }
    } else {
      console.log('zero cost order')
      $('.activation-form').submit()
    }
  }

  determineButtonValidity() {
    var enabled = true
    if (this.hasTermsTarget) {
      if (this.termsTarget.checked) {
        $(".must-accept").removeClass("with-error")
        $(this.marketingOptInTarget)
          .removeClass('opacity-25')
          .removeClass('pointer-events-none')
      } else {
        $(this.marketingOptInTarget).find('input').prop('checked', false)
        $(this.marketingOptInTarget)
          .addClass('opacity-25')
          .addClass('pointer-events-none')
      }

      var enabled = this.termsTarget.checked
    }

    $(this.submitTarget).attr('disabled', !enabled)
  }

  showPaymentFields() {
    $(this.paymentCollectionInfoTarget).addClass('hidden')
    $(this.paymentFieldsTarget).removeClass('hidden')
  }

  hidePaymentFields() {
    $(this.paymentCollectionInfoTarget).removeClass('hidden')
    $(this.paymentFieldsTarget).addClass('hidden')
  }

  togglePaymentForm() {
    if (this.hasPaymentFormTarget) {
      $(this.paymentFormTarget).toggleClass('hidden')
    }
    this.useExistingCardValue = !this.useExistingCardValue
  }
}
